import { FLIGHT_POLICY_PATHS } from "../../constants/path";
import { routeConfig } from "../../interfaces/route";
import NotesPage from "./NotesPage";
import NotFoundPage from "../NotFoundPage";


const policyRouterConfig: routeConfig[] = [
    {
        path: FLIGHT_POLICY_PATHS.fuelPolicy,
        component: NotFoundPage,
    },
    {
        path: FLIGHT_POLICY_PATHS.noFlyZonesPolicy,
        component: NotesPage,
    },
    {
        path: FLIGHT_POLICY_PATHS.tankeringPolicy,
        component: NotesPage,
    },
    {
        path: FLIGHT_POLICY_PATHS.volcanicAshesPolicy,
        component: NotesPage,
    }
];

export default policyRouterConfig;